import { DemoRepository } from "@/data/demo-repository"
import type { EditorialRepository } from "@/data/repository"
import { SupabaseRepository } from "@/data/supabase-repository"
import { env } from "@/lib/env"

export const repository: EditorialRepository = env.demoMode ? new DemoRepository() : new SupabaseRepository()
